// extracted by mini-css-extract-plugin
export var label = "_co-1";
export var reminder = "_co-0";